import { render, staticRenderFns } from "./MoneyV2.vue?vue&type=template&id=e4a5c17c&scoped=true"
import script from "./MoneyV2.vue?vue&type=script&lang=ts"
export * from "./MoneyV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a5c17c",
  null
  
)

export default component.exports